<!--
Author: TangChen
Date: 2018-10-15
Desc: 开户表单页面，为公共组件
 -->
<template>
    <div class="comp-open-acct-dc comp">
        <!-- 证件开户填写信息 -->
        <el-form
            ref="acctInfo"
            :model="acctInfo"
            :rules="rules"
            label-width="160px"
            class="pwdForm open-box"
            inline-message
            v-on:submit.native.prevent
        >
            <blockquote v-if="pwdTxt">
                <divide-title :title="pwdTxt" />
                <el-row>
                    <el-col :span="11">
                        <el-form-item :label="pwdTxt" prop="pwd" class="required lh22">
                            <el-input
                                v-model.trim="acctInfo.pwd"
                                :type="pwdType"
                                :placeholder="pwdTxt"
                                :maxlength="pwdMaxLength"
                            >
                                <i
                                    slot="suffix"
                                    :class="iconCla"
                                    aria-hidden="true"
                                    v-on:click="pwdTypeChange"
                                />
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="rePwdTxt" prop="pwdConfirm" class="required lh22">
                            <el-input
                                v-model.trim="acctInfo.pwdConfirm"
                                :type="pwdType"
                                :placeholder="rePwdTxt"
                                :maxlength="pwdMaxLength"
                            >
                                <i
                                    slot="suffix"
                                    :class="iconCla"
                                    aria-hidden="true"
                                    v-on:click="pwdTypeChange"
                                />
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="pwdRuleText">
                    <el-col :span="24">
                        <div class="pwd-rule-info">{{ pwdRuleText }}</div>
                    </el-col>
                </el-row>
            </blockquote>
            <divide-title title="完善信息" />
            <el-row>
                <el-col :span="11">
                    <el-form-item label="国籍:" prop="country" class="required">
                        <el-select
                            v-model.trim="acctInfo.country"
                            placeholder="请选择国籍"
                            filterable
                            :filter-method="filterCountry"
                            :disabled="countryDisabled"
                        >
                            <el-option
                                v-for="item in country"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            >
                                <span style="float: left">{{ item.subitemname }}</span>
                                <span style="float: right; color: var(--color-text-accent); font-size: 12px">
                                    {{ item.subitem }}
                                </span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        v-if="data.certType !== '00' && data.certType !== '0B'"
                        class="radio-list required"
                        label="性别:"
                        prop="sex"
                    >
                        <el-radio-group v-model="acctInfo.sex">
                            <el-radio v-for="item in sex" :key="item.subitem" :label="item.subitem">
                                {{ item.subitemname }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item class="required lh22" label="对账单寄送周期:" prop="delivertype">
                        <el-select
                            v-model="acctInfo.delivertype"
                            placeholder="请选择对账单寄送周期"
                        >
                            <el-option
                                v-for="item in delivertype"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="邮政编码:" prop="postcode" class="required">
                        <el-input
                            v-model.trim="acctInfo.postcode"
                            placeholder="请输入邮政编码"
                            :maxlength="6"
                        />
                    </el-form-item>
                    <el-form-item label="年收入(元):" prop="annualincome" class="required">
                        <el-input
                            v-model.trim="acctInfo.annualincome"
                            placeholder="请输入年收入"
                            :maxlength="16"
                            @input="handleAnnualIncomeInput"
                        />
                    </el-form-item>
                </el-col>

                <el-col :span="13">
                    <el-form-item label="学历:" prop="educationlevel" class="required">
                        <el-select
                            v-model.trim="acctInfo.educationlevel"
                            filterable
                            placeholder="请选择学历"
                        >
                            <el-option
                                v-for="item in educationlevel"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="职业:" prop="occupation" class="required">
                        <el-select
                            v-model.trim="acctInfo.occupation"
                            filterable
                            placeholder="请选择职业"
                        >
                            <el-option
                                v-for="item in occupation"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="对账单寄送方式:"
                        class="lh22"
                        prop="deliverway"
                        :class="acctInfo.delivertype === '1' ? '' : 'required'"
                    >
                        <el-select
                            v-model="acctInfo.deliverway"
                            placeholder="请选择对账单寄送方式"
                            :disabled="acctInfo.delivertype === '1'"
                            multiple
                            maxlength="32"
                            clearable
                        >
                            <el-option
                                v-for="item in deliverways"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="邮箱:" prop="email" class="required">
                        <el-input
                            v-model.trim="acctInfo.email"
                            placeholder="请输入电子邮箱"
                            :maxlength="32"
                        />
                    </el-form-item>
                    <!-- <el-form-item
                        v-if="acctInfo.occupation === '14' || acctInfo.occupation === '29'"
                        label="职业补充信息:"
                        prop="vocationsupple"
                        :class="{
                            required: acctInfo.occupation === '14' || acctInfo.occupation === '29'
                        }"
                    >
                        <el-input
                            v-model.trim="acctInfo.vocationsupple"
                            placeholder="请输入职业补充信息"
                            :maxlength="22"
                        />
                    </el-form-item> -->
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" class="col-input-w100">
                    <el-form-item label="电话号码:" prop="telno">
                        <el-select
                            v-model="acctInfo.telnocycode"
                            placeholder="请选择国家码"
                            style="width: 218px !important; margin-right: 21px"
                        >
                            <el-option
                                v-for="item in faxcycode"
                                :key="item.subitem"
                                :label="item.subitemname + ' ' + item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-select
                            v-if="acctInfo.telnocycode == '86'"
                            v-model="acctInfo.telnoareacode"
                            placeholder="请选择地区码"
                            style="width: 218px !important; margin-right: 21px"
                            filterable
                            :filter-method="filterMethod"
                            v-on:focus="handleFilter"
                            v-on:change="handleFilter"
                        >
                            <el-option
                                v-for="item in faxareacode"
                                :key="item.subitem"
                                :label="item.subitemname + ' ' + item.subitem"
                                :value="item.subitem"
                            >
                                <div>{{ item.subitemname + " " + item.subitem }}</div>
                            </el-option>
                        </el-select>
                        <el-input
                            v-else
                            v-model.trim="acctInfo.telnoareacodeinput"
                            placeholder="请输入地区码"
                            style="width: 218px !important; margin-right: 21px"
                        />
                        <el-input
                            v-model.trim="acctInfo.telno"
                            placeholder="请输入电话号码"
                            :maxlength="11"
                            style="width: 454px"
                        />
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24" class="lh22 col-input-w100">
                    <country-city-select
                        ref="livingaddress"
                        v-model="livingAddressObj"
                        class="user-address"
                        select-wdiht="width: 218px !important"
                        required
                        country-layout="user"
                    ></country-city-select>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="详细地址:" prop="address" class="required">
                        <el-input
                            v-model.trim="acctInfo.address"
                            placeholder="请输入详细地址"
                            :maxlength="300"
                            style="width: 933px !important"
                            v-on:input="handleAddressInput('address')"
                        />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" class="col-input-w100">
                    <el-form-item
                        v-if="acctInfo.deliverway.includes('2')"
                        label="传真号码:"
                        prop="fax"
                        class="required"
                    >
                        <el-select
                            v-model="acctInfo.faxcycode"
                            placeholder="请选择国家码"
                            style="width: 218px !important; margin-right: 21px"
                        >
                            <el-option
                                v-for="item in faxcycode"
                                :key="item.subitem"
                                :label="item.subitemname + ' ' + item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-select
                            v-if="acctInfo.faxcycode == '86'"
                            v-model="acctInfo.faxareacode"
                            placeholder="请选择地区码"
                            style="width: 218px !important; margin-right: 21px"
                            filterable
                            :filter-method="filterMethod"
                            v-on:focus="handleFilter"
                            v-on:change="handleFilter"
                        >
                            <el-option
                                v-for="item in faxareacode"
                                :key="item.subitem"
                                :label="item.subitemname + ' ' + item.subitem"
                                :value="item.subitem"
                            >
                                <div>{{ item.subitemname + " " + item.subitem }}</div>
                            </el-option>
                        </el-select>
                        <el-input
                            v-else
                            v-model.trim="acctInfo.faxareacodeinput"
                            placeholder="请输入地区码"
                            style="width: 218px !important; margin-right: 21px"
                        />
                        <el-input
                            v-model.trim="acctInfo.fax"
                            placeholder="请输入传真号码"
                            :maxlength="8"
                            style="width: 454px"
                        />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="11" class="lh22">
                    <el-form-item label="特定自然人标识:" prop="natural" class="required lh22">
                        <el-select
                            v-model.trim="acctInfo.natural"
                            filterable
                            placeholder="请选择特定自然人标识"
                        >
                            <el-option
                                v-for="item in natural"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" class="lh22">
                    <el-form-item
                        v-if="
                            !$util.isEmpty(acctInfo.natural) &&
                            acctInfo.natural !== '0' &&
                            acctInfo.natural !== 'A'
                        "
                        prop="assetssource"
                        label="财产和资金来源:"
                        :class="{ required: acctInfo.natural !== '0' && acctInfo.natural !== 'A' }"
                    >
                        <el-input
                            v-model.trim="acctInfo.assetssource"
                            placeholder="请输入财产和资金来源"
                            :maxlength="32"
                        />
                    </el-form-item>
                </el-col>
            </el-row>

            <!--235-->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="受益人类型:" prop="benefisself" class="required lh22">
                        <el-select
                            v-model.trim="acctInfo.benefisself"
                            placeholder="请选择受益人类型"
                        >
                            <el-option
                                v-for="item in benefisself"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item class="pwd-text">
                        <div class="info">
                            基金账户/交易账户项下基金交易的实际受益人。如实际受益人为本人，请选择本人；如实际受益人为他人，请根据系统提示填写相关信息。
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="acctInfo.benefisself === '0'">
                <el-col :span="12" class="lh22">
                    <el-form-item
                        label="实际受益人证件类型:"
                        prop="beneficiarytype"
                        class="required cert-types-line"
                    >
                        <el-select
                            v-model.trim="acctInfo.beneficiarytype"
                            placeholder="请选择受益人证件类型"
                            v-on:change="changeBenefitTypeFn"
                        >
                            <el-option
                                v-for="item in beneficiarytype"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-button
                            v-show="ocrUpdBtnS"
                            :disabled="ocrDis"
                            type="primary"
                            v-on:click="ocrShow = true"
                        >
                            {{ ocrBtnText }}
                        </el-button>
                    </el-form-item>
                    <el-form-item label="实际受益人证件号码:" prop="beneficiaryno" class="required">
                        <el-input
                            v-model.trim="acctInfo.beneficiaryno"
                            placeholder="请输入受益人证件号码"
                            :maxlength="32"
                            :disabled="dis"
                            v-on:blur="changeBenefitTypeFn"
                        />
                    </el-form-item>
                    <el-form-item label="受益人性别:" prop="beneficiarysex" class="required">
                        <el-radio-group v-model="acctInfo.beneficiarysex" :disabled="benefitSexDis">
                            <el-radio
                                v-for="item in beneficiarysex"
                                :key="item.subitem"
                                :label="item.subitem"
                            >
                                {{ item.subitemname }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="受益人职业:" prop="beneficiaryvocation" class="required">
                        <el-select
                            v-model.trim="acctInfo.beneficiaryvocation"
                            filterable
                            placeholder="请选择职业"
                        >
                            <el-option
                                v-for="item in occupation"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="受益人邮箱:" prop="beneficiaryemail" class="required">
                        <el-input
                            v-model.trim="acctInfo.beneficiaryemail"
                            placeholder="请输入电子邮箱"
                            :maxlength="32"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12" class="lh22">
                    <el-form-item label="受益人姓名:" prop="beneficiary" class="required">
                        <el-input
                            v-model.trim="acctInfo.beneficiary"
                            placeholder="请输入受益人姓名"
                            :disabled="dis"
                            :maxlength="acctInfo.beneficiarytype === '0B' ? 46 : 20"
                        />
                    </el-form-item>
                    <el-form-item
                        label="实际受益人证件有效期:"
                        prop="beneficiarydate"
                        class="required"
                    >
                        <date-picker
                            ref="beneficiaryDateSet"
                            :date="beneficiaryDateSet"
                            v-on:date-get="beneficiaryDateInterval"
                        />
                    </el-form-item>
                    <el-form-item
                        label="受益人出生日期:"
                        prop="beneficiarybirthday"
                        class="birthdate-select required"
                    >
                        <date-picker :date="dateBenefSetBirth" v-on:date-get="dateInterval_birth" />
                    </el-form-item>
                    <el-form-item label="受益人与持有人关系:" prop="benefrelation" class="required">
                        <el-input
                            v-model.trim="acctInfo.benefrelation"
                            placeholder="请输入受益人与持有人关系"
                        />
                    </el-form-item>
                    <el-form-item
                        label="受益人邮政编码:"
                        prop="beneficiarypostcode"
                        class="required"
                    >
                        <el-input
                            v-model.trim="acctInfo.beneficiarypostcode"
                            placeholder="请输入邮政编码"
                            :maxlength="6"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24" class="col-input-w100 lh22">
                    <el-form-item label="手机号码:" prop="beneficiarytelno" class="required">
                        <!-- <el-select
                            v-model="acctInfo.beneficiarytelnocycode"
                            placeholder="请选择国家码"
                            style="width: 218px !important; margin-right: 21px"
                        >
                            <el-option
                                v-for="item in cncountrycode"
                                :key="item.subitem"
                                :label="item.subitemname + ' ' + item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-select
                            v-if="acctInfo.beneficiarytelnocycode == '86'"
                            v-model="acctInfo.beneficiarytelnoareacode"
                            placeholder="请选择地区码"
                            style="width: 218px !important; margin-right: 21px"
                            filterable
                            :filter-method="filterMethod"
                            v-on:focus="handleFilter"
                            v-on:change="handleFilter"
                        >
                            <el-option
                                v-for="item in faxareacode"
                                :key="item.subitem"
                                :label="item.subitemname + ' ' + item.subitem"
                                :value="item.subitem"
                            >
                                <div>{{ item.subitemname + " " + item.subitem }}</div>
                            </el-option>
                        </el-select>
                        <el-input
                            v-else
                            v-model.trim="acctInfo.beneficiarytelnoareacodeinput"
                            placeholder="请输入地区码"
                            style="width: 218px !important; margin-right: 21px"
                        /> -->
                        <el-input
                            v-model.trim="acctInfo.beneficiarytelno"
                            style="width: 300px"
                            placeholder="请输入账户受益人的手机号码"
                            :maxlength="11"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24" class="col-input-w100 lh22">
                    <country-city-select
                        ref="benefAddress"
                        v-model="benefAddressObj"
                        class="user-address"
                        select-wdiht="width: 218px !important"
                        required
                        country-layout="user"
                    ></country-city-select>
                    <el-form-item label="受益人详细地址:" prop="beneficiaryaddr" class="required">
                        <el-input
                            v-model.trim="acctInfo.beneficiaryaddr"
                            placeholder="请输入受益人详细地址"
                            :maxlength="300"
                            style="width: 933px !important"
                            v-on:input="handleAddressInput('beneficiaryaddr')"
                        />
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24" class="lh22">
                    <el-form-item label="控制人类型:" prop="actualisself" class="required">
                        <el-select
                            v-model.trim="acctInfo.actualisself"
                            placeholder="请选择控制人类型"
                        >
                            <el-option
                                v-for="item in actualisself"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item class="pwd-text">
                        <div class="info">
                            指实际控制客户的自然人。如无控制人，请选择本人，如存在控制人，请根据系统提示填写相关信息。
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- 控制人开始 -->
            <el-row v-if="acctInfo.actualisself === '0'" class="lh22">
                <el-col :span="12">
                    <el-form-item
                        label="实际控制人证件类型:"
                        prop="actualctrlidtype"
                        class="required cert-types-line"
                    >
                        <el-select
                            v-model.trim="acctInfo.actualctrlidtype"
                            placeholder="请选择控制人证件类型"
                            v-on:change="changeActualctrlTypeFn"
                        >
                            <el-option
                                v-for="item in actualctrlidtype"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-button
                            v-show="ocrUpdBtnS2"
                            :disabled="ocrDis2"
                            type="primary"
                            v-on:click="ocrShow2 = true"
                        >
                            {{ ocrBtnText }}
                        </el-button>
                    </el-form-item>
                    <el-form-item
                        label="实际控制人证件号码:"
                        prop="actualctrlidcode"
                        class="required"
                    >
                        <el-input
                            v-model.trim="acctInfo.actualctrlidcode"
                            placeholder="请输入控制人证件号码"
                            :maxlength="32"
                            :disabled="dis2"
                            v-on:blur="changeActualctrlTypeFn"
                        />
                    </el-form-item>
                    <el-form-item label="控制人性别:" prop="actualctrlsex" class="required">
                        <el-radio-group v-model="acctInfo.actualctrlsex" :disabled="actualSexDis">
                            <el-radio
                                v-for="item in actualctrlsex"
                                :key="item.subitem"
                                :label="item.subitem"
                            >
                                {{ item.subitemname }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="控制人职业:" prop="actualctrlvocation" class="required">
                        <el-select
                            v-model.trim="acctInfo.actualctrlvocation"
                            filterable
                            placeholder="请选择职业"
                        >
                            <el-option
                                v-for="item in actualctrlvocation"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="控制人邮箱:" prop="actualctrlemail" class="required">
                        <el-input
                            v-model.trim="acctInfo.actualctrlemail"
                            placeholder="请输入电子邮箱"
                            :maxlength="32"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="控制人姓名:" prop="actualctrlname" class="required">
                        <el-input
                            v-model.trim="acctInfo.actualctrlname"
                            placeholder="请输入控制人姓名"
                            :disabled="dis2"
                            :maxlength="acctInfo.actualctrlidtype === '0B' ? 46 : 20"
                        />
                    </el-form-item>

                    <el-form-item
                        label="实际控制人证件有效期:"
                        prop="actualctrlvalidate"
                        class="required"
                    >
                        <date-picker
                            ref="actualctrlDateSet"
                            :date="actualctrlDateSet"
                            v-on:date-get="actualctrlDateInterval"
                        />
                    </el-form-item>
                    <el-form-item
                        label="控制人出生日期:"
                        prop="actualctrlbirthday"
                        class="birthdate-select required"
                    >
                        <date-picker :date="dateSetBirth" v-on:date-get="dateInterval_birth2" />
                    </el-form-item>
                    <el-form-item
                        label="控制人与持有人关系:"
                        prop="actualrelation"
                        class="required"
                    >
                        <el-input
                            v-model.trim="acctInfo.actualrelation"
                            placeholder="请输入控制人与持有人关系"
                        />
                    </el-form-item>
                    <el-form-item
                        label="控制人邮政编码:"
                        prop="actualctrlpostcode"
                        class="required"
                    >
                        <el-input
                            v-model.trim="acctInfo.actualctrlpostcode"
                            placeholder="请输入邮政编码"
                            :maxlength="6"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24" class="col-input-w100">
                    <el-form-item label="手机号码:" prop="actualctrltelno" class="required">
                        <!-- <el-select
                            v-model="acctInfo.actualctrltelnocycode"
                            placeholder="请选择国家码"
                            style="width: 218px !important; margin-right: 21px"
                        >
                            <el-option
                                v-for="item in actualctrltelnocycode"
                                :key="item.subitem"
                                :label="item.subitemname + ' ' + item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-select
                            v-if="acctInfo.actualctrltelnocycode == '86'"
                            v-model="acctInfo.actualctrltelnoareacode"
                            placeholder="请选择地区码"
                            style="width: 218px !important; margin-right: 21px"
                            filterable
                            :filter-method="filterMethod"
                            v-on:focus="handleFilter"
                            v-on:change="handleFilter"
                        >
                            <el-option
                                v-for="item in faxareacode"
                                :key="item.subitem"
                                :label="item.subitemname + ' ' + item.subitem"
                                :value="item.subitem"
                            >
                                <div>{{ item.subitemname + " " + item.subitem }}</div>
                            </el-option>
                        </el-select>
                        <el-input
                            v-else
                            v-model.trim="acctInfo.actualctrltelnoareacodeinput"
                            placeholder="请输入地区码"
                            style="width: 218px !important; margin-right: 21px"
                        /> -->
                        <el-input
                            v-model.trim="acctInfo.actualctrltelno"
                            style="width: 300px"
                            placeholder="请输入账户控制人的手机号码"
                            :maxlength="11"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24" class="col-input-w100">
                    <country-city-select
                        ref="actualAddress"
                        v-model="actualAddressObj"
                        class="user-address"
                        select-wdiht="width: 218px !important"
                        required
                        country-layout="user"
                    ></country-city-select>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="控制人详细地址:" prop="actualctrladdr" class="required">
                        <el-input
                            v-model.trim="acctInfo.actualctrladdr"
                            placeholder="请输入控制人详细地址"
                            :maxlength="300"
                            style="width: 933px !important"
                            v-on:input="handleAddressInput('actualctrladdr')"
                        />
                    </el-form-item>
                </el-col>
            </el-row>
            <divide-title title="税收身份声明" />
            <el-row>
                <el-col :span="24" class="lh22">
                    <el-form-item label="税收身份声明:" prop="nonresiflag" class="required">
                        <el-select
                            v-model.trim="acctInfo.nonresiflag"
                            placeholder="请选择控制人类型"
                        >
                            <el-option
                                v-for="item in taxestypes"
                                v-show="item.subitem !== '3'"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <!--非中国税收居民-->
        <open-acct-crs
            v-if="['1', '2'].includes(acctInfo.nonresiflag)"
            ref="crsInfo"
            :open-par="data"
            v-on:get-acct-crs="getAcctCrs"
        ></open-acct-crs>
        <el-form>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="本人保证:">
                        <div class="checkbox-circle">
                            <el-checkbox
                                v-model="checkbox"
                                class="checkbox-dc"
                                size="mini"
                            ></el-checkbox>
                            <span>
                                本人保证提供的信息真实、准确完整，知晓并确认若提供的信息不真实、不准确、不完整的，当依法承担相应的法律责任。{{
                                    $const.COMPANY
                                }}基金将不承担由此导致适当性不匹配的任何后果，且有权拒绝销售产品或服务。本人已知悉并确认提供信息发生重要变化可能影响投资者分类的，应当及时进行更新并告知基金。
                            </span>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <agreement
                        v-model="protocol"
                        style="margin-left: 0"
                        :data="agrType"
                        v-on:all-read="agreePro"
                    ></agreement>
                </el-col>
                <el-col :span="24">
                    <div class="open-acct-btn">
                        <el-button class="medium dc-cancel-btn" v-on:click="backPage">
                            返回
                        </el-button>
                        <el-button type="primary" class="medium" v-on:click.prevent="submitInfo()">
                            保存
                        </el-button>
                    </div>
                </el-col>
            </el-row>
        </el-form>
        <ocr-upd-dialog
            :visible="ocrShow"
            :cert-type="acctInfo.beneficiarytype"
            check-flag="1"
            :skip-open-acct-check="true"
            :minor-allow-open="true"
            v-on="{ success: imgUp, back: regression }"
        />
        <ocr-upd-dialog
            :visible="ocrShow2"
            :cert-type="acctInfo.actualctrlidtype"
            check-flag="1"
            :skip-open-acct-check="true"
            :minor-allow-open="minorAllowOpen"
            v-on="{ success: imgUp2, back: regression2 }"
        />
    </div>
</template>
<script>
import agreement from "@/components/form/agreement.vue";
import datePicker from "@/components/form/datePicker.vue";
import format from "date-fns/format";
import countryCitySelect from "@/components/acct/countryCitySelect.vue";
import divideTitle from "@/components/form/divideTitle";
import openAcctCrs from "@/components/form/openAcctCrs.vue";
import ocrUpdDialog from "@/components/form/ocrUpdDialog.vue";
import { sceneEnum } from "@/util/util_jfit";
export default {
    name: "Tab",
    components: {
        agreement,
        datePicker,
        countryCitySelect,
        divideTitle,
        openAcctCrs,
        ocrUpdDialog
    },
    props: {
        data: {
            type: Object,
            default: function () {
                return {};
            }
        },
        crmCustInfo: {
            type: Object,
            default: function () {
                return {};
            }
        }
    },
    data() {
        return {
            livingAddressObj: {
                country: "CN",
                province: null,
                city: null,
                county: null,
                address: null
            },
            benefAddressObj: {
                country: "CN",
                province: null,
                city: null,
                county: null,
                address: null
            },
            actualAddressObj: {
                country: "CN",
                province: null,
                city: null,
                county: null,
                address: null
            },
            dateSetBirth: { type: "1", max: "", dis: false, val: "", text: "请选择出生日期" },
            dateBenefSetBirth: { type: "1", max: "", dis: false, val: "", text: "请选择出生日期" },
            country: [],
            originCountry: [], // 原始国家数据，用于搜索过滤
            delivertype: [], // 对账单寄送类型
            deliverways: [], // 对账单寄送类型
            beneficiarytype: [],
            benefisself: [],
            sex: [], // 性别
            pwdType: "password",
            agrType: sceneEnum.open, // 协议类型，开户协议
            iconCla: "fa fa-eye-slash",
            natural: [],
            isdigniaryorceo: [],
            cncountrycode: [],
            beneficiarysex: [],
            beneficiaryvocation: [], // 受益人职业
            assetssource: "", // 资金来源
            beneficiaryaddrcity: [], // 受益人城市
            beneficiaryaddrcounty: [], // 受益人县
            addresscity: [],
            addresscounty: [],
            faxareacode: [],
            actualisself: [], // 控制人
            actualctrlvocation: [],
            actualctrltelnocycode: [],
            actualctrlsex: [],
            actualctrlidtype: [],
            actualctrlcountry: [],
            actualctrladdrprovince: [],
            actualctrladdrcounty: [],
            actualctrladdrcity: [],
            faxcycode: [],
            acctInfo: {
                // 交易账户信息
                pwd: "",
                pwdConfirm: "",
                loginpwd: "",
                loginPwdConfirm: "",
                delivertype: "",
                deliverway: [],
                email: "",
                annualincome: "",
                faxcycode: "86",
                faxareacode: "",
                fax: "",
                faxareacodeinput: "",
                telnocycode: "",
                telno: "",
                telnoareacode: "",
                telnoareacodeinput: "",
                address: "",
                postcode: "",
                country: "CN",
                nonresiflag: "",
                province: "",
                livingcountry: "", // 国家
                sex: "",
                branchcode: "",
                benefisself: "",
                beneficiary: "",
                beneficiarytype: "",
                beneficiaryno: "",
                beneficiarydate: "",
                // assetssource: "",
                // actualctrlvalidate:"",
                // assetssource: "",
                //                    income:'',
                cnprovince: "",
                cncity: "",
                county: "", // 县
                cncountry: "",
                natural: "",
                isdigniaryorceo: "",
                cncountrycode: "中国+86",
                mobile: "",
                assetssource: "", // 资金来源
                beneficiarycountry: "", // 受益人国家
                beneficiaryaddrprovince: "", // 受益人省份
                beneficiaryaddrcity: "", // 受pack益人城市
                beneficiaryaddrcounty: "", // 受益人县
                beneficiaryemail: "", // 受益人邮箱
                beneficiarypostcode: "", // 受益人邮箱编码
                beneficiarysex: "", // 受益人性别
                beneficiaryvocation: "", // 受益人职业
                beneficiarytelnocycode: "86", // 国家码
                beneficiarytelnoareacode: "",
                beneficiarytelnoareacodeinput: "",
                beneficiarytelno: "", // 手机号
                beneficiaryaddr: "", // 受益人详细地址
                addressprovince: "",
                addresscity: "",
                addresscounty: "",
                beneficiarybirthday: "", // 受益人出生日期
                benefrelation: "",
                cnprovice: "",
                occupation: "",
                actualisself: "", // 控制人
                actualctrlvocation: "",
                actualctrltelnocycode: "86",
                actualctrltelnoareacode: "",
                actualctrltelnoareacodeinput: "",
                actualctrlsex: "",
                actualctrlidtype: "",
                actualctrlcountry: "",
                actualctrladdrprovince: "",
                actualctrladdr: "",
                actualctrladdrcity: "",
                actualctrladdrcounty: "",
                actualctrlbirthday: "",
                actualctrlemail: "",
                actualctrlidcode: "",
                actualctrlname: "",
                actualctrlpostcode: "",
                actualctrltelno: "",
                actualctrlvalidate: "",
                actualrelation: ""
            },
            actualctrlDateSet: { type: "3", max: "", val: "", text: "请选择证件有效期" },
            beneficiaryDateSet: { type: "3", max: "", val: "", text: "请选择证件有效期" },
            protocol: false,
            occupation: [],
            vocationcode: [],
            educationlevel: [],
            // assetssource: [],
            infoText: "如果下拉选项中及搜索结果中没有您的开户行，请选择附近的开户行",
            query: null, // 定时查找
            rules: {
                // 校验规则
                pwd: [
                    { required: true, validator: this.$util.validateTPwd, trigger: "blur" },
                    { validator: this.confirm, trigger: "blur" }
                ],
                pwdConfirm: [
                    { required: true, validator: this.$util.validateTPwd, trigger: "blur" },
                    { validator: this.confirm, trigger: "blur" }
                ],
                natural: [{ required: true, message: "请选择特定自然人标识", trigger: "change" }],
                educationlevel: [{ required: true, message: "请选择学历", trigger: "change" }],
                isdigniaryorceo: [
                    { required: true, message: "请选择受益人类型", trigger: "change" }
                ],
                sex: [{ required: true, message: "请选择性别", trigger: "change" }],
                delivertype: [
                    { required: true, message: "请选择对账单寄送周期", trigger: "change" }
                ],
                occupation: [{ required: true, message: "请选择职业", trigger: "change" }],
                deliverway: [{ validator: this.validateDeliverway, trigger: "change" }],
                address: [
                    { required: true, validator: this.validateLivingaddress, trigger: "blur" }
                ],
                benefisself: [{ required: true, message: "请选择受益人类型", trigger: "change" }],
                beneficiary: [{ validator: this.validateBeneficiary, trigger: "blur" }],
                beneficiarytype: [{ validator: this.validateBeneficiarytype, trigger: "change" }],
                beneficiaryno: [{ validator: this.validateBeneficiaryno, trigger: "blur" }],
                beneficiarydate: [{ validator: this.validateBeneficiarydate, trigger: "blur" }],
                beneficiarytelno: [
                    { required: true, message: "请输入账户受益人的手机号码", trigger: "blur" },
                    {
                        validator: this.$util.validateMobile,
                        trigger: "blur",
                        validName: "beneficiarytelno"
                    }
                ],
                beneficiarybirthday: [
                    { required: true, validator: this.$util.validateDate, trigger: "blur" }
                ],
                beneficiarysex: [{ required: true, message: "请选择性别", trigger: "change" }],
                beneficiaryvocation: [{ required: true, message: "请选择职业", trigger: "change" }],
                beneficiaryemail: [{ validator: this.$util.validateEmail, trigger: "blur" }],
                beneficiarypostcode: [{ validator: this.$util.validatePostCode, trigger: "blur" }],
                beneficiaryaddr: [{ validator: this.validateBeneficiaryaddr, trigger: "blur" }],
                benefrelation: [
                    { required: true, message: "请输入受益人与持有人关系", trigger: "blur" }
                ],
                actualisself: [{ required: true, message: "请选择控制人类型", trigger: "change" }],
                actualctrlname: [{ validator: this.validateActualctrlname, trigger: "blur" }],
                actualctrlsex: [{ required: true, message: "请选择性别", trigger: "change" }],
                actualctrlidtype: [{ validator: this.validateActualctrlidtype, trigger: "change" }],
                actualctrlidcode: [{ validator: this.validateActualctrl, trigger: "blur" }],
                actualctrlbirthday: [
                    { required: true, validator: this.$util.validateDate, trigger: "blur" }
                ],
                actualctrlvalidate: [
                    { validator: this.validateMin, trigger: "blur" },
                    { validator: this.$util.validateDate, trigger: "blur" }
                ],
                actualctrltelno: [
                    { required: true, message: "请输入账户控制人的手机号码", trigger: "blur" },
                    {
                        validator: this.$util.validateMobile,
                        trigger: "blur",
                        validName: "actualctrltelno"
                    }
                ],
                actualctrlvocation: [{ required: true, message: "请选择职业", trigger: "change" }],
                actualctrlpostcode: [{ validator: this.validatePostCode2, trigger: "blur" }],
                actualctrlemail: [{ validator: this.$util.validateEmail, trigger: "blur" }],
                actualctrladdr: [
                    { required: true, validator: this.validateActualctrladdr, trigger: "blur" }
                ],
                actualrelation: [
                    { required: true, message: "请输入控制人与持有人关系", trigger: "blur" }
                ],
                /* selectedOptions: [
                    { validator: this.validateSelectedOptions, trigger: "change" }
                ], */
                livingaddress: [{ validator: this.validateLivingaddress, trigger: "blur" }],
                assetssource: [{ validator: this.validateAssetssource, trigger: "blur" }],
                province: [{ validator: this.validateLocation, trigger: "change" }],
                bankname: [
                    { required: true, message: "请选择开户行名称", trigger: "change" },
                    { validator: this.$util.validateBankName, trigger: "change" }
                ],
                vocationsupple: [
                    { required: true, validator: this.validateVocationsupple, trigger: "blur" }
                ],
                postcode: [
                    { required: true, message: "请输入邮政编码", trigger: "blur" },
                    { validator: this.$util.validatePostCode, trigger: "blur" }
                ],
                email: [
                    { required: true, message: "请输入电子邮箱", trigger: "blur" },
                    { validator: this.$util.validateEmail, trigger: "blur" }
                ],
                telno: [{ validator: this.validateFax, trigger: "blur", validName: "telno" }],
                annualincome: [
                    { required: true, message: "请输入年收入", trigger: "blur" },
                    { validator: this.validateAnnualIncome, trigger: "blur" }
                ],
                fax: [{ validator: this.validateFax, trigger: "blur", validName: "fax" }]
            },
            options: [],
            showAddrTip: false,
            pwdText: "",
            checkbox: false,
            taxestypes: [],
            province: [],
            faxareacodeOld: "",
            benefitSexDis: false,
            actualSexDis: false,
            // 受益人和控制人orc相关的
            minorAllowOpen: false,
            ocrUpdBtnS: false,
            ocrShow: false,
            dis: false,
            ocrUpdBtnS2: false,
            ocrShow2: false,
            dis2: false,
            ocrBtnText: "上传证件照"
        };
    },
    computed: {
        isIdCardOpenAcct() {
            return this.data.certType === "00";
        },
        countryDisabled() {
            return this.isIdCardOpenAcct || this.data.countryOcr;
        },
        ocrDis: function () {
            return !this.$cache.isOcrCertTypeSupported(this.acctInfo.beneficiarytype);
        },
        ocrDis2: function () {
            return !this.$cache.isOcrCertTypeSupported(this.acctInfo.actualctrlidtype);
        },
        passwordType() {
            return this.$cache.getCompanyInfoParam("10109008");
        },
        registerType() {
            return this.$cache.getCompanyInfoParam("10109007");
        },
        // 交易密码长度上限（根据公司参数 10104014 配置）
        pwdMaxLength() {
            const len = Number(this.$cache.getCompanyInfoParam("10104014") || "16");
            return isNaN(len) ? 16 : len;
        },
        pwdTxt() {
            const noRegisterOrNotLogin =
                this.registerType === "0" || !this.$store.state.login.status;

            if (this.passwordType === "0") {
                return noRegisterOrNotLogin ? "设置密码" : "";
            }

            return noRegisterOrNotLogin ? "设置登录/交易密码" : "设置交易密码";
        },
        rePwdTxt() {
            const noRegisterOrNotLogin =
                this.registerType === "0" || !this.$store.state.login.status;

            if (this.passwordType === "0") {
                return noRegisterOrNotLogin ? "再次输入密码" : "";
            }

            return noRegisterOrNotLogin ? "确认登录/交易密码" : "确认交易密码";
        },
        // 这里实质是交易密码，只是单密码等情况下也是登录密码
        pwdRuleText() {
            if (!this.pwdTxt) return "";
            return this.$util.initTPwdCheckText();
        }
    },
    watch: {
        "acctInfo.natural"(val) {
            this.acctInfo.assetssource = "";
        },
        "acctInfo.beneficiarytype"(val) {
            // 使用新的证件类型OCR支持判断方法
            const isOcrSupported = this.$cache.isOcrCertTypeSupported(val);
            if (val === "00" || val === "0B") {
                this.dateBenefSetBirth.dis = true;
                this.ocrUpdBtnS = isOcrSupported;
                this.beneficiaryDateSet.dis = isOcrSupported;
                // 支持OCR时禁用输入框（等待OCR回填），不支持时允许手动输入
                this.dis = isOcrSupported;
                this.acctInfo.beneficiary = "";
                this.acctInfo.beneficiaryno = "";
                this.acctInfo.beneficiarysex = "";
                this.acctInfo.beneficiarydate = "";
                this.acctInfo.beneficiarybirthday = "";
                this.$set(this.beneficiaryDateSet, "val", "");
                this.$set(this.dateBenefSetBirth, "val", "");
                setTimeout(() => {
                    this.$refs.acctInfo.clearValidate([
                        "beneficiary",
                        "beneficiaryno",
                        "beneficiarysex",
                        "beneficiarydate",
                        "beneficiarybirthday"
                    ]);
                }, 1000);
            } else {
                // this.dateBenefSetBirth.dis = false;
                this.ocrUpdBtnS = false;
                this.beneficiaryDateSet.dis = false;
                this.dis = false;
            }
        },
        "acctInfo.actualctrlidtype"(val) {
            // 使用新的证件类型OCR支持判断方法
            const isOcrSupported = this.$cache.isOcrCertTypeSupported(val);
            if (val === "00" || val === "0B") {
                this.dateSetBirth.dis = true;
                this.ocrUpdBtnS2 = isOcrSupported;
                this.actualctrlDateSet.dis = isOcrSupported;
                // 支持OCR时禁用输入框（等待OCR回填），不支持时允许手动输入
                this.dis2 = isOcrSupported;
                this.acctInfo.actualctrlname = "";
                this.acctInfo.actualctrlidcode = "";
                this.acctInfo.actualctrlsex = "";
                this.acctInfo.actualctrlvalidate = "";
                this.acctInfo.actualctrlbirthday = "";
                this.$set(this.actualctrlDateSet, "val", "");
                this.$set(this.dateSetBirth, "val", "");
                setTimeout(() => {
                    this.$refs.acctInfo.clearValidate([
                        "actualctrlname",
                        "actualctrlidcode",
                        "actualctrlsex",
                        "actualctrlvalidate",
                        "actualctrlbirthday"
                    ]);
                }, 1000);
            } else {
                // this.dateSetBirth.dis = false;
                this.ocrUpdBtnS2 = false;
                this.actualctrlDateSet.dis = false;
                this.dis2 = false;
            }
        },
        "acctInfo.delivertype"(val) {
            if (val === "1") {
                this.acctInfo.deliverway = [];
            }
        },
        "acctInfo.occupation"(val) {
            if (val !== "14" && val !== "29") {
                this.acctInfo.vocationsupple = "";
            }
        },
        "acctInfo.benefisself"(val) {
            this.acctInfo.beneficiary = "";
            this.acctInfo.beneficiarytype = "";
            this.acctInfo.beneficiaryno = "";
            this.acctInfo.beneficiarydate = "";
            this.acctInfo.beneficiarysex = "";
            this.acctInfo.beneficiarybirthday = "";
            this.acctInfo.beneficiaryvocation = "";
            this.acctInfo.beneficiarytelnocycode = "";
            this.acctInfo.beneficiarytelnoareacode = "";
            this.acctInfo.beneficiarytelnoareacodeinput = "";
            this.acctInfo.beneficiarytelno = "";
            this.acctInfo.beneficiarycountry = "";
            this.acctInfo.beneficiaryaddrprovince = "";
            this.acctInfo.beneficiaryaddrcity = "";
            this.acctInfo.beneficiaryaddrcounty = "";
            this.acctInfo.beneficiaryaddr = "";
            this.acctInfo.beneficiaryemail = "";
            this.acctInfo.beneficiarypostcode = "";
            this.acctInfo.benefrelation = "";
            this.acctInfo.beneficiarytelnocycode = "";
            this.$set(this.beneficiaryDateSet, "val", "");
            this.$set(this.dateBenefSetBirth, "val", "");
            this.$set(this.beneficiaryDateSet, "time", new Date().getTime());
            this.$set(this.dateBenefSetBirth, "time", new Date().getTime());
            this.benefAddressObj = {
                country: "CN",
                province: null,
                city: null,
                county: null
            };
        },
        "acctInfo.actualisself"(val) {
            this.acctInfo.actualctrlname = "";
            this.acctInfo.actualctrlidtype = "";
            this.acctInfo.actualctrlidcode = "";
            this.acctInfo.actualctrldate = "";
            this.acctInfo.actualctrlsex = "";
            this.acctInfo.actualctrlbirthday = "";
            this.acctInfo.actualctrlvocation = "";
            this.acctInfo.actualctrltelnocycode = "";
            this.acctInfo.actualctrltelnoareacode = "";
            this.acctInfo.actualctrltelnoareacodeinput = "";
            this.acctInfo.actualctrltelno = "";
            this.acctInfo.actualctrlcountry = "";
            this.acctInfo.actualctrladdrprovince = "";
            this.acctInfo.actualctrladdrcity = "";
            this.acctInfo.actualctrladdrcounty = "";
            this.acctInfo.actualctrladdr = "";
            this.acctInfo.actualctrlemail = "";
            this.acctInfo.actualctrlpostcode = "";
            this.acctInfo.actualrelation = "";
            this.acctInfo.actualctrltelnocycode = "";
            this.$set(this.actualctrlDateSet, "val", "");
            this.$set(this.dateSetBirth, "val", "");
            this.$set(this.actualctrlDateSet, "time", new Date().getTime());
            this.$set(this.dateSetBirth, "time", new Date().getTime());
            this.actualAddressObj = {
                country: "CN",
                province: null,
                city: null,
                county: null,
                address: null
            };
            console.log(this.actualAddressObj);
        },
        "acctInfo.telnocycode"(val) {
            this.acctInfo.telnoareacode = "";
            this.acctInfo.telnoareacodeinput = "";
        },
        "acctInfo.telnoareacodeinput"(val) {
            this.acctInfo.telnoareacode = this.acctInfo.telnoareacodeinput;
        },
        "acctInfo.faxcycode"(val) {
            this.acctInfo.faxareacode = "";
            this.acctInfo.faxareacodeinput = "";
        },
        "acctInfo.faxareacodeinput"(val) {
            this.acctInfo.faxareacode = this.acctInfo.faxareacodeinput;
        },
        // "acctInfo.faxcycode"(val){
        //     if(val != "86"){
        //         this.acctInfo.faxareacode = "";
        //     }
        // },
        "acctInfo.beneficiarytelnocycode"(val) {
            this.acctInfo.beneficiarytelnoareacode = "";
            this.acctInfo.beneficiarytelnoareacodeinput = "";
        },
        "acctInfo.beneficiarytelnoareacodeinput"(val) {
            this.acctInfo.beneficiarytelnoareacode = this.acctInfo.beneficiarytelnoareacodeinput;
        },
        "acctInfo.actualctrltelnocycode"(val) {
            this.acctInfo.actualctrltelnoareacode = "";
            this.acctInfo.actualctrltelnoareacodeinput = "";
        },
        "acctInfo.actualctrltelnoareacodeinput"(val) {
            this.acctInfo.actualctrltelnoareacode = this.acctInfo.actualctrltelnoareacodeinput;
        }
    },
    mounted() {
        this.info = this.$cache.getUser();
        this.minorAllowOpen = this.$cache.getCompanyInfoParam("10105005") == "1";
        // 国家/国籍数据：将中国及港澳台置顶
        this.country = this.$util.sortCountryWithChinaFirst(this.$cache.getDict("120109"));
        // 保存原始数据用于搜索
        this.originCountry = [...this.country];
        this.province = this.$cache.getDict("190021");
        this.delivertype = this.$cache.getDict("110046");
        this.deliverways = this.$cache.getDict("100013");
        this.faxcycode = this.$util.changeArrIndex(this.$cache.getDict("150136"), "86");
        this.faxareacode = this.$cache.getDict("150137");
        this.faxareacodeOld = this.$cache.getDict("150137");
        this.benefisself = [...this.$cache.getDict("120137")].reverse();
        this.beneficiarytype = this.$cache.getDict("130007");
        this.occupation = this.$cache.getDict("150141");
        this.vocationcode = this.$cache.getDict("100011");
        // this.cncountry = this.$cache.getDict("120109")
        // this.cnprovice = this.$cache.getDict("190021")
        this.natural = this.$cache.getDict("120200"); // 自然
        this.educationlevel = this.$cache.getDict("20011");
        this.isdigniaryorceo = this.$cache.getDict("120200");
        // this.cncountrycode = this.$cache.getDict("150136"); //国家码
        this.cncountrycode = this.$util.changeArrIndex(this.$cache.getDict("150136"), "86");
        this.beneficiarysex = this.$cache.getDict("110059"); // 受益人性别
        this.beneficiaryvocation = this.$cache.getDict("150141");
        this.taxestypes = this.$cache.getDict("120043");
        // 控制人
        this.actualisself = [...this.$cache.getDict("120137")].reverse();
        this.actualctrlvocation = this.$cache.getDict("150141");
        // this.actualctrltelnocycode = this.$cache.getDict("150136"); //国家码
        this.actualctrltelnocycode = this.$util.changeArrIndex(this.$cache.getDict("150136"), "86");
        this.actualctrlsex = this.$cache.getDict("110059");
        this.actualctrlidtype = this.$cache.getDict("130007");
        this.actualctrlcountry = this.$cache.getDict("120109");
        this.actualctrladdrprovince = this.$cache.getDict("190021");
        const conf = this.$util.getConfig().const;
        this.assetssource = this.$cache.getDict("120073");
        this.assetssource.forEach((item) =>
            item.subitem === "4" ? (item.subitemname = "其他收入") : ""
        );
        this.actualctrlDateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.beneficiaryDateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        const birthmax = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 18, true);
        this.dateSetBirth.max = this.$util.fmtDate(birthmax);
        this.dateSetBirth.min = this.$util.fmtDate("19000101");
        this.$set(this.actualctrlDateSet, "val", "");
        this.$set(this.beneficiaryDateSet, "val", "");
        this.dateBenefSetBirth.max = this.$util.fmtDate(birthmax);
        this.dateBenefSetBirth.min = this.$util.fmtDate("19000101");
        this.$set(this.dateBenefSetBirth, "val", "");
        this.$set(this.dateBenefSetBirth, "time", new Date().getTime());
        let _y = [];
        let _z = [];
        this.sex = this.$cache.getDict("110059").reverse();
        this.$cache.initCityCountyList();
        this.options = this.$util.initAddrCascaderOps();
        if (this.crmCustInfo && this.crmCustInfo.custname) {
            this.initCrmCustInfo();
        }
        // this.initAddress();
        this.pwdText = this.$util.initTPwdCheckText();
        this.setCertCountry();
        // 根据配置参数限制字典选项（通用处理）
        this.applyDictLimitConfig();
    },
    methods: {
        setCertCountry() {
            if (this.isIdCardOpenAcct) {
                this.acctInfo.country = this.$const.CN;
            } else if (this.data.countryOcr) {
                this.acctInfo.country = this.data.country;
            }
        },
        // 根据国家名称和国家码搜索过滤
        filterCountry(query) {
            if (query) {
                this.country = this.originCountry.filter((item) => {
                    const name = item.subitemname && item.subitemname.toLowerCase();
                    const code = item.subitem && item.subitem.toLowerCase();
                    const searchQuery = query.toLowerCase();
                    return name && name.includes(searchQuery) || code && code.includes(searchQuery);
                });
            } else {
                this.country = [...this.originCountry];
            }
        },
        imgUp(flag) {
            this.dateBenefSetBirth.dis = true;
            this.beneficiaryDateSet.dis = true;
            if (flag) {
                this.acctInfo.beneficiaryno = flag.certificateno;
                this.acctInfo.beneficiary = flag.custname;
            }
            this.acctInfo.beneficiarysex = this.getSex(this.acctInfo.beneficiaryno);
            this.beneficiaryDateSet.val = this.$util.fmtDate(flag.vailddate);
            this.acctInfo.beneficiarydate =
                this.beneficiaryDateSet.val != ""
                    ? this.beneficiaryDateSet.val.replace(/-/g, "")
                    : "";
            // 处理OCR返回的birthday字段
            if (flag && flag.birthday) {
                const birthdayFormatted = flag.birthday.replace(/\//g, "-");
                this.dateBenefSetBirth.val = birthdayFormatted;
                this.acctInfo.beneficiarybirthday = birthdayFormatted.replace(/-/g, "");
            }
            // 长期有效的勾选框渲染
            this.$nextTick(() => {
                if (this.beneficiaryDateSet.val == "9999-12-31") {
                    this.$refs.beneficiaryDateSet.checked = true;
                    this.$refs.beneficiaryDateSet.dateChange();
                }
            });
            this.initBirthdate(); /* 从证件号截取 */
            setTimeout(() => {
                this.$refs.acctInfo.clearValidate([
                    "beneficiary",
                    "beneficiaryno",
                    "beneficiarysex",
                    "beneficiarydate",
                    "beneficiarybirthday"
                ]);
            }, 1000);
        },
        initBirthdate() {
            // 身份证
            if (this.acctInfo.beneficiarytype === "00") {
                const sIdNo = this.acctInfo.beneficiaryno;
                const that = this;
                that.acctInfo.beneficiarybirthday = that.$util.getBirthdate(
                    sIdNo,
                    that.acctInfo.beneficiarytype
                );
                that.$set(
                    that.dateBenefSetBirth,
                    "val",
                    that.$util.fmtDate(that.acctInfo.beneficiarybirthday, "-")
                );
            }
        },
        regression() {
            this.ocrShow = false;
        },
        imgUp2(flag) {
            this.dateSetBirth.dis = true;
            this.actualctrlDateSet.dis = true;
            if (flag) {
                this.acctInfo.actualctrlidcode = flag.certificateno;
                this.acctInfo.actualctrlname = flag.custname;
            }
            this.acctInfo.actualctrlsex = this.getSex(this.acctInfo.actualctrlidcode);
            this.actualctrlDateSet.val = this.$util.fmtDate(flag.vailddate);
            this.acctInfo.actualctrlvalidate =
                this.actualctrlDateSet.val != ""
                    ? this.actualctrlDateSet.val.replace(/-/g, "")
                    : "";
            // 处理OCR返回的birthday字段
            if (flag && flag.birthday) {
                const birthdayFormatted = flag.birthday.replace(/\//g, "-");
                this.dateSetBirth.val = birthdayFormatted;
                this.acctInfo.actualctrlbirthday = birthdayFormatted.replace(/-/g, "");
            }
            // 长期有效的勾选框渲染
            this.$nextTick(() => {
                if (this.actualctrlDateSet.val == "9999-12-31") {
                    this.$refs.actualctrlDateSet.checked = true;
                    this.$refs.actualctrlDateSet.dateChange();
                }
            });
            this.initBirthdate2(); /* 从证件号截取 */
            setTimeout(() => {
                this.$refs.acctInfo.clearValidate([
                    "actualctrlname",
                    "actualctrlidcode",
                    "actualctrlsex",
                    "actualctrlvalidate",
                    "actualctrlbirthday"
                ]);
            }, 1000);
        },
        initBirthdate2() {
            // 身份证
            if (this.acctInfo.actualctrlidtype === "00") {
                const sIdNo = this.acctInfo.actualctrlidcode;
                const that = this;
                that.acctInfo.actualctrlbirthday = that.$util.getBirthdate(
                    sIdNo,
                    that.acctInfo.actualctrlidtype
                );
                that.$set(
                    that.dateSetBirth,
                    "val",
                    that.$util.fmtDate(that.acctInfo.actualctrlbirthday, "-")
                );
            }
        },
        regression2() {
            this.ocrShow2 = false;
        },
        validateAnnualIncome(rule, value, callback) {
            if (this.$util.isEmpty(value)) {
                callback(new Error("请输入年收入"));
            } else if (!/^\d+$/.test(value)) {
                callback(new Error("年收入只能输入数字"));
            } else if (Number(value) <= 0) {
                callback(new Error("年收入必须大于0"));
            } else {
                callback();
            }
        },
        handleAnnualIncomeInput(value) {
            // 只允许输入数字
            this.acctInfo.annualincome = value.replace(/[^0-9]/g, "");
        },
        validateFax(rule, value, callback) {
            this.acctInfo[rule.validName] = value.replace(/[^0-9]/g, "");
            value = this.acctInfo[rule.validName];
            if (rule.validName == "fax") {
                if (this.acctInfo.deliverway.includes("2")) {
                    this.$util.validateFaxNum(rule, value, callback);
                } else {
                    callback();
                }
            } else if (rule.validName == "telno") {
                if (this.acctInfo.telno.trim()) {
                    this.$util.validateFaxNum(rule, value, callback);
                } else {
                    callback();
                }
            } else {
                this.$util.validateFaxNum(rule, value, callback);
            }
        },
        // 年收入输入实时过滤非数字
        handleAnnualIncomeInput() {
            this.acctInfo.annualincome = this.acctInfo.annualincome.replace(/[^0-9]/g, "");
        },
        // 改变受益人证件类型和受益人证件号码，出生日期，性别，证件有效期需要控制
        changeBenefitTypeFn() {
            // 受益人为非本人且证件类型为身份证时
            if (
                this.acctInfo.benefisself == "0" &&
                (this.acctInfo.beneficiarytype == "00" || this.acctInfo.beneficiarytype == "0B")
            ) {
                this.$set(this.dateBenefSetBirth, "dis", true);
                this.benefitSexDis = true;
                this.acctInfo.beneficiarysex = this.getSex(this.acctInfo.beneficiaryno);
                this.$util.validateCertNo(
                    "",
                    this.acctInfo.beneficiaryno,
                    () => {
                        this.$set(
                            this.dateBenefSetBirth,
                            "val",
                            this.$util.fmtDate(
                                this.$util.getBirthdate(
                                    this.acctInfo.beneficiaryno,
                                    this.acctInfo.beneficiarytype
                                )
                            )
                        );
                        this.acctInfo.beneficiarybirthday = this.dateBenefSetBirth.val.replace(
                            /-/g,
                            ""
                        );
                        this.changeBenefitValidateFn();
                    },
                    this.acctInfo.beneficiarytype
                );
                setTimeout(() => {
                    this.$refs.acctInfo.clearValidate(["beneficiarysex", "beneficiarybirthday"]);
                }, 1000);
            } else {
                this.beneficiaryDateSet.longHidden = false;
                this.$set(this.dateBenefSetBirth, "dis", false);
                this.benefitSexDis = false;
            }
        },
        // 受益人证件有效期长期有效是否展示
        changeBenefitValidateFn() {
            this.beneficiaryDateSet.val = this.acctInfo.beneficiarydate
                ? format(this.acctInfo.beneficiarydate, "YYYY-MM-DD")
                : "";
            const isFlag = this.$util.isOver46YearsOld(
                this.acctInfo.beneficiaryno,
                this.dateBenefSetBirth.val.replace(/-/g, "")
            );
            this.beneficiaryDateSet = Object.assign({}, this.beneficiaryDateSet);
            if (isFlag) {
                this.beneficiaryDateSet.longHidden = false;
            } else {
                this.beneficiaryDateSet.longHidden = true;
                if (this.beneficiaryDateSet.val == "9999-12-31") {
                    this.beneficiaryDateSet.val = "";
                    this.acctInfo.beneficiarydate = "";
                    this.$nextTick(() => {
                        this.$refs.acctInfo.validateField("beneficiarydate");
                    });
                }
            }
        },
        // 改变控制人证件类型和控制人证件号码，出生日期，性别，证件有效期需要控制
        changeActualctrlTypeFn() {
            // 控制人为非本人且证件类型为身份证时
            if (
                this.acctInfo.actualisself == "0" &&
                (this.acctInfo.actualctrlidtype == "00" || this.acctInfo.actualctrlidtype == "0B")
            ) {
                this.$set(this.dateSetBirth, "dis", true);
                this.actualSexDis = true;
                this.acctInfo.actualctrlsex = this.getSex(this.acctInfo.actualctrlidcode);
                this.$util.validateCertNo(
                    "",
                    this.acctInfo.actualctrlidcode,
                    () => {
                        this.$set(
                            this.dateSetBirth,
                            "val",
                            this.$util.fmtDate(
                                this.$util.getBirthdate(
                                    this.acctInfo.actualctrlidcode,
                                    this.acctInfo.actualctrlidtype
                                )
                            )
                        );
                        this.acctInfo.actualctrlbirthday = this.dateSetBirth.val.replace(/-/g, "");
                        this.changeActualctrlValidateFn();
                    },
                    this.acctInfo.actualctrlidtype
                );
                setTimeout(() => {
                    this.$refs.acctInfo.clearValidate(["actualctrlsex", "actualctrlbirthday"]);
                }, 1000);
            } else {
                this.actualctrlDateSet.longHidden = false;
                this.$set(this.dateSetBirth, "dis", false);
                this.actualSexDis = false;
            }
        },
        // 控制人证件有效期长期有效是否展示
        changeActualctrlValidateFn() {
            this.actualctrlDateSet.val = this.acctInfo.actualctrlvalidate
                ? format(this.acctInfo.actualctrlvalidate, "YYYY-MM-DD")
                : "";
            const isFlag = this.$util.isOver46YearsOld(
                this.acctInfo.actualctrlidcode,
                this.dateSetBirth.val.replace(/-/g, "")
            );
            this.actualctrlDateSet = Object.assign({}, this.actualctrlDateSet);
            if (isFlag) {
                this.actualctrlDateSet.longHidden = false;
            } else {
                this.actualctrlDateSet.longHidden = true;
                if (this.actualctrlDateSet.val == "9999-12-31") {
                    this.actualctrlDateSet.val = "";
                    this.acctInfo.actualctrlvalidate = "";
                    this.$nextTick(() => {
                        this.$refs.acctInfo.validateField("actualctrlvalidate");
                    });
                }
            }
        },
        // 根据身份证号判断性别
        getSex(psidno) {
            let sexno = "";
            if (psidno.length === 18) {
                sexno = psidno.substring(16, 17);
            } else if (psidno.length === 15) {
                sexno = psidno.substring(14, 15);
            } else {
                return "";
            }
            const tempid = sexno % 2;
            return tempid === 0 ? "2" : "1";
        },
        filterMethod(query) {
            this.faxareacode = this.faxareacodeOld.filter((item) => {
                if ((item.subitemname + item.subitem).indexOf(query) > -1) {
                    return item;
                }
            });
        },
        handleFilter() {
            this.faxareacode = this.faxareacodeOld;
        },
        initCrmCustInfo() {
            this.acctInfo.postcode = this.crmCustInfo.postcode || "";
            this.acctInfo.email = this.crmCustInfo.email || "";
            this.acctInfo.sex = this.crmCustInfo.sex || "";
            this.acctInfo.address = this.crmCustInfo.address || "";
            this.acctInfo.postcode = this.crmCustInfo.postcode || "";
            this.acctInfo.telno = this.crmCustInfo.telno || "";
            this.acctInfo.fax = this.crmCustInfo.fax || "";
            this.acctInfo.occupation = this.crmCustInfo.vocationcode || "";
        },
        setLivingAddr() {
            // 现居国家、省、市、县
            this.acctInfo["cncountry"] = this.livingAddressObj["country"];
            this.acctInfo["cnprovince"] = this.livingAddressObj["province"];
            this.acctInfo["cncity"] = this.livingAddressObj["city"];
            this.acctInfo["cncounty"] = this.livingAddressObj["county"];
        },
        // 受益人国家、省、市、县
        setBenefAddress() {
            this.acctInfo["beneficiarycountry"] = this.benefAddressObj["country"];
            this.acctInfo["beneficiaryaddrprovince"] = this.benefAddressObj["province"];
            this.acctInfo["beneficiaryaddrcity"] = this.benefAddressObj["city"];
            this.acctInfo["beneficiaryaddrcounty"] = this.benefAddressObj["county"];
        },
        // 控制人国家、省、市、县
        setActualAddress() {
            this.acctInfo["actualctrlcountry"] = this.actualAddressObj["country"];
            this.acctInfo["actualctrladdrprovince"] = this.actualAddressObj["province"];
            this.acctInfo["actualctrladdrcity"] = this.actualAddressObj["city"];
            this.acctInfo["actualctrladdrcounty"] = this.actualAddressObj["county"];
        },
        checkAddressInfo() {
            let hasLivingAddrInfo = true;
            if (this.acctInfo.cncountry === this.$const.CN) {
                let hasCounties = true;
                if (
                    this.$refs.livingaddress &&
                    this.$refs.livingaddress.hasCounties !== undefined
                ) {
                    hasCounties = this.$refs.livingaddress.hasCounties;
                }
                hasLivingAddrInfo =
                    !!this.acctInfo.cnprovince &&
                    !!this.acctInfo.address &&
                    !!this.acctInfo.cncity &&
                    (hasCounties ? !!this.acctInfo.cncounty : true);
            } else {
                hasLivingAddrInfo = !!this.acctInfo.address;
            }
            if (!hasLivingAddrInfo) {
                this.$alert("请完善现居地址(国家/地区-省-市-县)信息！", "提示");
                return false;
            }
            return true;
        },
        checkBenefActualInfo() {
            let hasBenefInfo = true;
            let hasCtrlInfo = true;
            if (this.acctInfo.benefisself === "0") {
                let excludeitems = []; // 有些地方没有县
                if (this.acctInfo.beneficiarycountry !== this.$const.CN) {
                    excludeitems = excludeitems.concat(["province", "city", "county"]);
                } else if (
                    this.$refs.benefAddress &&
                    this.$refs.benefAddress.hasCounties === false
                ) {
                    // 国内但城市无县/区数据
                    excludeitems.push("county");
                }
                this.benefAddressObj.address = this.acctInfo.beneficiaryaddr;
                hasBenefInfo = this.$util.checkInfoFilled(this.benefAddressObj, excludeitems);
            }
            if (this.acctInfo.actualisself === "0") {
                let excludeitems = []; // 有些地方没有县
                if (this.acctInfo.actualctrlcountry !== this.$const.CN) {
                    excludeitems = excludeitems.concat(["province", "city", "county"]);
                } else if (
                    this.$refs.actualAddress &&
                    this.$refs.actualAddress.hasCounties === false
                ) {
                    // 国内但城市无县/区数据
                    excludeitems.push("county");
                }
                this.actualAddressObj.address = this.acctInfo.actualctrladdr;
                hasCtrlInfo = this.$util.checkInfoFilled(this.actualAddressObj, excludeitems);
            }

            if (!hasCtrlInfo) {
                this.$alert("请完善实际控制人地址(国家/地区-省-市-县)信息！", "提示");
                return false;
            }
            if (!hasBenefInfo) {
                this.$alert("请完善实际受益人地址(国家/地区-省-市-县)信息！", "提示");
                return false;
            }
            return true;
        },
        // 判断特定自然人标识
        checkValidiDNatural() {
            if (this.acctInfo.natural && this.acctInfo.natural != "0") {
                this.$message.warning(
                    "如果您为外国政要及其特定关系人、国际组织高管及其特定关系人，根据相关法律法规要求，" +
                        "请联系基金客服进一步提供资料。给您造成的不便，敬请谅解。"
                );
                return false;
            }
            return true;
        },
        // 判断受益人
        dateInterval_birth(val) {
            this.acctInfo.beneficiarybirthday = val !== null ? val.replace(/-/g, "") : "";
        },
        dateInterval_birth2(val) {
            this.acctInfo.actualctrlbirthday = val !== null ? val.replace(/-/g, "") : "";
        },
        matched() {
            let match = false;
            this.city.forEach((item) => {
                if (item.cityid === this.acctInfo.city) {
                    match = true;
                }
            });
            return match;
        },
        initAddress(val) {
            let address = this.data.address;
            let provinceMatched = false;
            let cityMatched = false;
            let countyMatched = false;
            this.acctInfo.selectedOptions[0] = (val && val.value) || "";
            let _province = (this.acctInfo.bankprovince = (val && val.label) || "");
            try {
                this.options.forEach((province) => {
                    if ((provinceMatched || _province) && cityMatched && countyMatched) {
                        throw new Error("end loop");
                    }
                    if (address.indexOf(province.label) !== -1) {
                        this.acctInfo.selectedOptions[0] = province.value;
                        this.acctInfo.bankprovince = province.label;
                        _province = province.label;
                        address = address.substring(
                            address.lastIndexOf(province.label) + province.label.length
                        );
                        provinceMatched = true;
                    }
                    if (provinceMatched || val) {
                        province = val || province;
                        provinceMatched = !!val;
                        try {
                            province.children.forEach((city) => {
                                if (cityMatched && countyMatched) {
                                    throw new Error("end loop");
                                }
                                if (
                                    address.indexOf(city.label) !== -1 ||
                                    _province === city.label
                                ) {
                                    // 考虑直辖市情况（北京市平谷区）
                                    this.acctInfo.selectedOptions[1] = city.value;
                                    this.acctInfo.city = city.label;
                                    if (_province !== city.label) {
                                        address = address.substring(
                                            address.indexOf(city.label) + city.label.length
                                        );
                                    }
                                    cityMatched = true;
                                }
                                if (cityMatched) {
                                    try {
                                        city.children &&
                                            city.children.forEach((county, index) => {
                                                if (address.indexOf(county.label) !== -1) {
                                                    this.acctInfo.selectedOptions[2] = county.value;
                                                    address = address.substring(
                                                        address.indexOf(county.label) +
                                                            county.label.length
                                                    );
                                                    countyMatched = true;
                                                    throw new Error("end loop");
                                                }
                                                if (index === city.children.length - 1) {
                                                    // 身份证地址没有区默认取第一个
                                                    this.acctInfo.selectedOptions[2] =
                                                        city.children[0].value;
                                                    countyMatched = true;
                                                }
                                            });
                                    } catch (e) {
                                        this.$log.error(e);
                                    }
                                    this.acctInfo.livingaddress = address;
                                }
                            });
                        } catch (e) {
                            this.$log.error(e);
                        }
                        if (!cityMatched) {
                            // 没有市 #山东省（青岛市）平度市XXXX
                            try {
                                province.children.forEach((city) => {
                                    city.children &&
                                        city.children.forEach((county) => {
                                            if (address.indexOf(county.label) !== -1) {
                                                this.acctInfo.selectedOptions[1] = city.value;
                                                this.acctInfo.city = city.label;
                                                this.acctInfo.selectedOptions[2] = county.value;
                                                address = address.substring(
                                                    address.indexOf(county.label) +
                                                        county.label.length
                                                );
                                                cityMatched = true;
                                                countyMatched = true;
                                                throw new Error("end loop");
                                            }
                                        });
                                });
                            } catch (e) {
                                this.$log.error(e);
                            }
                            this.acctInfo.livingaddress = address;
                        }
                    }
                });
            } catch (e) {
                this.$log.error(e);
            }
            if (!provinceMatched) {
                // 身份证地址没有省份  广州市XXXX
                try {
                    this.options.forEach((province) => {
                        province.children.forEach((city) => {
                            if (address.indexOf(city.label) !== -1) {
                                this.initAddress(province);
                                throw new Error("end loop");
                            }
                        });
                    });
                } catch (e) {
                    this.$log.error(e);
                }
            }
        },
        setAddress() {
            this.options.forEach((province) => {
                if (province.value === this.acctInfo.selectedOptions[0]) {
                    this.acctInfo.address = province.label;
                    try {
                        province.children.forEach((city) => {
                            if (city.value === this.acctInfo.selectedOptions[1]) {
                                this.acctInfo.address += city.label;
                                city.children &&
                                    city.children.forEach((county) => {
                                        if (county.value === this.acctInfo.selectedOptions[2]) {
                                            this.acctInfo.address += county.label;
                                            throw new Error("end loop");
                                        }
                                    });
                                throw new Error("end loop");
                            }
                        });
                    } catch (e) {
                        this.$log.error(e);
                    }
                }
            });
            this.acctInfo.address += this.acctInfo.livingaddress;
        },
        validateEmail(rule, value, callback) {
            if (this.acctInfo.deliverway.includes("3") || value !== "") {
                this.$util.validateEmail(rule, value, callback);
            } else {
                callback();
            }
        },
        validateVocationsupple(rule, value, callback) {
            if (
                (this.acctInfo.occupation === "14" || this.acctInfo.occupation === "29") &&
                !value
            ) {
                callback(new Error("请输入职业补充信息"));
            } else {
                callback();
            }
        },
        /* 确认密码校验 */
        confirm(rule, value, callback) {
            if (
                this.acctInfo.pwd !== this.acctInfo.pwdConfirm &&
                this.acctInfo.pwd !== "" &&
                this.acctInfo.pwdConfirm !== ""
            ) {
                callback(new Error("输入密码和确认密码不一致"));
            } else {
                callback();
            }
        },
        agreePro(val) {
            this.protocol = false;
            if (!val) return;
            this.setCertCountry();
            /* if (this.acctInfo.deliverway === "1") {
                this.acctInfo.email = "";
            } else if (this.acctInfo.deliverway === "3") {
                this.acctInfo.address = "";
                this.acctInfo.postcode = "";
            } */
            this.acctInfo.location =
                this.acctInfo.cncountry === "CN"
                    ? this.$cache.getDict("190021", this.acctInfo.cnprovince)
                    : this.$cache.getDict("120109", this.acctInfo.cncountry);
            this.acctInfo.belongregion = this.acctInfo.cncountry === "CN" ? "中国" : "外国";
            this.acctInfo.isdigniaryorceo = this.acctInfo.natural;
            this.acctInfo.beneficiarytelnocycode = this.acctInfo.benefisself == "0" ? "86" : "";
            this.acctInfo.actualctrltelnocycode = this.acctInfo.actualisself == "0" ? "86" : "";
            // this.setAddress();
            const _x = Object.assign(
                { multiplePasswordFlag: this.passwordType !== "0" },
                this.acctInfo
            );
            _x.deliverway = _x.deliverway ? _x.deliverway.join(",") : "";
            this.$emit("get-acct", _x);
        },
        validateLocation(rule, value, callback) {
            if (this.acctInfo.country === "CN") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请选择省份"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateAssetssource(rule, value, callback) {
            if (
                this.acctInfo.natural === "1" ||
                this.acctInfo.natural === "2" ||
                this.acctInfo.natural === "3" ||
                this.acctInfo.natural === "4"
            ) {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入收入来源"));
                }
            }
            if (!this.$util.isEmpty(value)) {
                this.$util.validateGeneral(rule, value, callback, "收入来源");
            } else {
                callback();
            }
        },
        validateBeneficiary(rule, value, callback) {
            if (this.acctInfo.benefisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入受益人姓名"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateBeneficiarytype(rule, value, callback) {
            if (this.acctInfo.benefisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请选择受益人证件类型"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateBeneficiaryno(rule, value, callback) {
            if (this.acctInfo.benefisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入受益人证件号码"));
                } else {
                    this.$util.validateCertNo(rule, value, callback, this.acctInfo.beneficiarytype);
                }
            } else {
                callback();
            }
        },
        validateBeneficiarydate(rule, value, callback) {
            if (this.acctInfo.benefisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请选择受益人证件有效期"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateBeneficiaryaddr(rule, value, callback) {
            if (this.acctInfo.benefisself === "0") {
                if (!value) {
                    callback(new Error("请输入受益人联系地址"));
                    return;
                }
                let len = 0;
                for (let i = 0; i < value.length; i++) {
                    if (value.charCodeAt(i) > 127 || value.charCodeAt(i) === 94) {
                        len += 2;
                    } else {
                        len++;
                    }
                }
                if (len < 12) {
                    callback(new Error("详细地址不小于6个汉字或12个字符！"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateActualctrladdr(rule, value, callback) {
            if (this.acctInfo.actualisself === "0") {
                if (!value) {
                    callback(new Error("请输入控制人联系地址"));
                    return;
                }
                let len = 0;
                for (let i = 0; i < value.length; i++) {
                    if (value.charCodeAt(i) > 127 || value.charCodeAt(i) === 94) {
                        len += 2;
                    } else {
                        len++;
                    }
                }
                if (len < 12) {
                    callback(new Error("详细地址不小于6个汉字或12个字符！"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateActualctrlname(rule, value, callback) {
            if (this.acctInfo.actualisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入控制人姓名"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateActualctrlidtype(rule, value, callback) {
            if (this.acctInfo.actualisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请选择控制人证件类型"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateActualctrl(rule, value, callback) {
            if (this.acctInfo.actualisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入控制人证件号码"));
                } else {
                    this.$util.validateCertNo(
                        rule,
                        value,
                        callback,
                        this.acctInfo.actualctrlidtype
                    );
                }
            } else {
                callback();
            }
        },
        validateMin(rule, value, callback) {
            if (Number(value) < Number(format(new Date(), "YYYYMMDD"))) {
                callback(new Error("证件有效期必须大于当前日期，请重新选择"));
            } else {
                callback();
            }
        },
        validatePostCode2(rule, value, callback) {
            this.$util.validatePostCode(rule, value, callback);
        },

        validateSelectedOptions(rule, value, callback) {
            if (value && value.length >= 1) {
                callback();
            } else {
                callback(new Error("请选择省市县"));
            }
        },
        validateLivingaddress(rule, value, callback) {
            if (!value) {
                callback(new Error("请输入详细地址"));
                return;
            }
            let len = 0;
            for (let i = 0; i < value.length; i++) {
                if (value.charCodeAt(i) > 127 || value.charCodeAt(i) === 94) {
                    len += 2;
                } else {
                    len++;
                }
            }
            if (len < 12) {
                callback(new Error("详细地址不小于6个汉字或12个字符！"));
            } else {
                callback();
            }
        },
        handleAddressInput(field) {
            const val = this.acctInfo[field];
            if (!val) return;
            this.acctInfo[field] = this.$util.truncateByByteLength(val, 300);
        },
        /* 返回上一页页 */
        backPage() {
            this.$emit("get-acct", false);
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo() {
            this.setCertCountry();
            if (
                (this.acctInfo.deliverway.includes("2") ||
                    this.acctInfo.deliverway.includes("5")) &&
                this.acctInfo.faxcycode === "86" &&
                this.acctInfo.faxareacode === ""
            ) {
                this.$alert("请选择地区码！");
                return;
            }
            this.setLivingAddr();
            this.setActualAddress();
            this.setBenefAddress();
            if (!this.checkAddressInfo() || !this.checkBenefActualInfo()) {
                return;
            }
            if (!this.checkValidiDNatural()) {
                return;
            }
            this.$refs.acctInfo.validate((valid, obj) => {
                if (valid) {
                    if (this.acctInfo.nonresiflag !== "0") {
                        this.$refs.crsInfo.submitInfo();
                        return false;
                    }
                    if (!this.checkbox) {
                        this.$alert("尊敬的客户，请您确认上述信息的真实、准确和完整！");
                        return false;
                    }
                    this.protocol = true;
                } else {
                    this.$errorScroll();
                    return false;
                }
            });
        },
        getAcctCrs(crsInfo) {
            if (!this.checkbox) {
                this.$alert("请阅读并同意以上信息！");
                return false;
            }
            this.acctInfo.crsInfo = crsInfo;
            this.protocol = true;
        },
        /* 密码显示或隐藏处理 */
        pwdTypeChange() {
            this.pwdType = this.pwdType === "text" ? "password" : "text";
            this.iconCla = this.pwdType === "text" ? "fa fa-eye" : "fa fa-eye-slash";
        },
        querySearchEmail(queryString, callback) {
            let confirmSuffix = "";
            if (
                queryString.indexOf("@") > -1 &&
                queryString.substring(queryString.indexOf("@")).length > 1
            ) {
                let suffix = queryString.substring(queryString.indexOf("@"));
                let emailSuffix =
                    this.$cache.getEmailSuffix() || this.$util.getConfig().defaultEmailSuffix;
                let delimiter = ",";
                if (emailSuffix.indexOf("，") > -1) {
                    delimiter = "，";
                }

                emailSuffix.split(delimiter).forEach((item) => {
                    if (item.indexOf(suffix) > -1) {
                        confirmSuffix += item + ",";
                    }
                });
                confirmSuffix = confirmSuffix.substring(0, confirmSuffix.length - 1);
                queryString = queryString.substring(0, queryString.indexOf("@"));
            } else if (queryString.indexOf("@") > -1) {
                queryString = queryString.substring(0, queryString.indexOf("@"));
            }
            let emailSuffix = this.getEmailSuffix(confirmSuffix);
            let results = Object.assign([], emailSuffix);
            for (let item in results) {
                results[item].value = queryString + "" + emailSuffix[item].value;
            }
            callback(results);
        },
        getEmailSuffix(suffix) {
            let emailSuffix =
                suffix || this.$cache.getEmailSuffix() || this.$util.getConfig().defaultEmailSuffix;
            let delimiter = ",";
            if (emailSuffix.indexOf("，") > -1) {
                delimiter = "，";
            }
            return emailSuffix.split(delimiter).map((item) => {
                return { value: item };
            });
        },
        // 受益人证件有效期
        beneficiaryDateInterval(val) {
            this.acctInfo.beneficiarydate = val != "" ? val.replace(/-/g, "") : "";
            this.$refs.acctInfo.validateField("beneficiarydate");
        },
        // 控制人证件有效期
        actualctrlDateInterval(val) {
            this.acctInfo.actualctrlvalidate = val != "" ? val.replace(/-/g, "") : "";
            this.$refs.acctInfo.validateField("actualctrlvalidate");
        },
        // dateInterval (val) {
        //     this.acctInfo.beneficiarydate = val !== null ? val.replace(/-/g, "") : "";
        //     this.$refs.acctInfo.validateField("beneficiarydate");
        // },
        specificnaturalper(fn) {
            var _param = {
                invtp: "1",
                certificatetype: this.data.certType,
                custfullname: this.data.custname,
                action: "Q"
            };
            this.$util.specificnaturalper(_param, (res) => {
                if (res != null) {
                    if (this.acctInfo.natural == "0") {
                        fn();
                    }
                }
            });
        },
        validateDeliverway(rule, value, callback) {
            if (
                !this.$util.isEmpty(this.acctInfo.delivertype) &&
                this.acctInfo.delivertype !== "1" &&
                (this.$util.isEmpty(value) || value.length === 0)
            ) {
                callback(new Error("请选择对账单寄送方式"));
            } else {
                callback();
            }
        },
        // 根据配置参数限制字典选项（通用处理）
        applyDictLimitConfig() {
            try {
                const accountInfo = this.$cache.getParamValue("account_open_control");
                if (this.$util.isEmpty(accountInfo)) return;
                const fields = accountInfo.fields || [];
                // key 与 options 属性名的映射关系（根据 getDict 赋值语句整理）
                const keyMap = {
                    deliverway: "deliverways", // dict: 100013
                    delivertype: "delivertype", // dict: 110046
                    benefisself: "benefisself", // dict: 120137
                    beneficiarytype: "beneficiarytype", // dict: 130007
                    occupation: "occupation", // dict: 150141
                    educationlevel: "educationlevel", // dict: 20011
                    isdigniaryorceo: "isdigniaryorceo", // dict: 120200
                    beneficiarysex: "beneficiarysex", // dict: 110059
                    taxestypes: "taxestypes", // dict: 120043
                    faxcycode: "faxcycode", // dict: 150136
                    faxareacode: "faxareacode", // dict: 150137
                    sex: "sex", // dict: 110059
                    actualisself: "actualisself", // dict: 120137
                    actualctrlvocation: "actualctrlvocation", // dict: 150141
                    actualctrlsex: "actualctrlsex", // dict: 110059
                    actualctrlidtype: "actualctrlidtype" // dict: 130007
                };
                fields.forEach((field) => {
                    const { key, dict, "dict-limit": dictLimit } = field;
                    if (!key || !dict || !dictLimit) return;
                    const prop = keyMap[key];
                    if (!prop || !this[prop]) return;
                    // 支持逗号分隔的多个值
                    const limitValues = dictLimit.split(",");
                    const dictItem = this.$cache.getDict(dict);
                    this[prop] = dictItem.filter((item) => limitValues.includes(item.subitem));
                });
            } catch (e) {
                console.error("解析 account_open_control 配置失败:", e);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.comp-open-acct-dc {
    margin-top: 28px;
    .open-box {
        .el-form-item {
            &.is-required .el-form-item__label:before {
                display: inline;
                content: "";
            }
            &.unrequired ::v-deep .el-form-item__label:before {
                display: inline;
                content: "";
            }
            &.required ::v-deep .el-form-item__label:before {
                display: inline;
                content: "*";
                color: $color-c;
                margin-right: 2px;
            }
            ::v-deep label.el-form-item__label {
                font-size: 14px;
                color: #333;
                margin-right: 8px;
                &:before {
                    display: inline;
                }
            }
        }
        ::v-deep .el-form-item.radio-list {
            margin-bottom: 22px;
        }
        // ::v-deep .lh22 label.el-form-item__label {
        //     line-height: 22px;
        // }
        .col-input-w100 {
            ::v-deep .el-input {
                width: 100%;
            }
        }
        .user-address ::v-deep label.el-form-item__label {
            font-size: 14px;
            margin-right: 8px;
            &:before {
                display: inline;
                content: "*";
                color: $color-c;
                margin-right: 2px;
            }
        }
    }
    .comp-divide-title {
        margin-bottom: 20px;
    }
    .comp-date-picker {
        width: 98%;
    }
    .checkbox-circle {
        display: flex;
        font-size: 16px;
        color: #999;
        span {
            margin-left: 10px;
            line-height: 26px;
        }
        ::v-deep .el-checkbox .el-checkbox__input .el-checkbox__inner {
            border-radius: 50%;
        }
    }
    .open-acct-btn {
        text-align: center;
        margin-bottom: 20px;
        .dc-cancel-btn {
            margin-right: 40px;
        }
        .el-button {
            width: 180px;
        }
    }
}
::v-deep .el-dialog__header {
    color: var(--color-text-primary);
    background-color: var(--color-bg-container);
    font-weight: bold;
}
.confirm-container {
    width: 92%;
    margin: 0 auto;
    height: auto;
}
.confirm-order-text {
    color: var(--color-text-primary);
    font-family: Source Han Sans CN;
    font-size: 18px;
    font-weight: normal;
    line-height: 32px;
}
.button-container {
    width: 100%;
    text-align: center;
    .btn-confirm {
        color: #fff;
        background-color: var(--color-primary);
        width: 150px;
        margin: 30px auto 0;
        padding: 10px 0;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
        &:hover {
            opacity: 0.7;
        }
    }
}
.confirm-btn {
    display: flex;
}

.pwd-text {
    margin-bottom: 0px;
    color: $text-color3;
    .el-form-item__content {
        line-height: 24px;
        .info {
            margin: 0 0 16px 5px;
            font-size: 12px;
        }
    }
}
.pwd-rule-info {
    margin: 0 0 0 168px;
    color: $text-color3;
}
.cert-types-line {
    ::v-deep .el-form-item__content {
        display: flex;
        flex-wrap: nowrap;
        overflow: visible;
        > .el-select,
        > .el-input {
            flex: 1;
            margin-right: 10px;
            flex-shrink: 0;
            width: auto !important;
        }
        > .el-button {
            flex-shrink: 0;
        }
    }
}
</style>
